import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';
import { Observable, forkJoin, concat } from 'rxjs';
import { map, toArray } from 'rxjs/operators';
import {
  ARBleAzoteFrequency,
  ARBleAzotePeriod,
  ARBleAzoteProductType,
  ARBleCIDestructionPeriod,
  ARBleCIDevelopment,
  ARBleCIType,
  ARBleEtatVegetatifSh,
  ARBleOrderType,
  ARBlePastResiduType,
  ARBlePrairieAge,
  ARBlePrairieDestructionPeriod,
  ARBlePrairieExploitationMode,
  ARBlePrairiePostDestructionRank,
  ARBlePrairieType,
  ARVerseApportMoAutomne,
  ARVerseApportsMinerauxFractionnement,
} from '../../../../models/agrorendement-ble-lists.model';
import { ARBleCampaign, ARBleOrderItem, ARBleParcel } from '../../../../models/agrorendement-ble.model';
import { PreventDoubleClickDirective } from '../../../../utils/preventDoubleClick';

import {
  ARConsoleFormatType,
  ARConsoleModulationType,
  ARConsoleType,
  ARConsoleVersion,
  ARFertilizerType,
} from '../../../../models/agrorendement-common-lists.model';
import {
  ARFertilizerData,
  ARFertilizerDnDataFacade,
  ARFertilizerT1DataFacade,
  ARFertilizerT2DataFacade,
  ARFertilizerT3DataFacade,
  ARVraData,
  ARVraDnDataFacade,
  ARVraT1DataFacade,
  ARVraT2DataFacade,
  ARVraT3DataFacade,
  CbBatchEditDn,
  CbBatchEditT1,
  CbBatchEditT2,
  CbBatchEditT3,
} from '../../../../models/agrorendement-common.model';
import { ListItem } from '../../../../models/lists.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { ARBleListsService, ARBleListType } from '../../../../services/agrorendement-ble-lists.service';
import { ARBleService } from '../../../../services/agrorendement-ble.service';
import { ARCommonListsService, ARCommonListType } from '../../../../services/agrorendement-common-lists.service';
import { ParcelService } from '../../../../services/parcel.service';
import { getBatchOrderItems, prepareBatchSave } from '../../../../utils/batchedit.utils';
import { Tooltip } from '../../../../utils/Tooltip';
// FIXME réorganiser : trop d\'imoprts
import { I18nTranslator } from '../../../../i18n/translate';
import { Organisation } from '../../../../models/organisation.model';
import { BeApiService } from '../../../../services/beapi.service';
import { KeycloakService } from '../../../../services/keycloak.service';
import { UserService } from '../../../../services/user.service';
import { TOOLTIP_TEXTS } from '../../../../utils/tooltip-texts';
import { TooltipContent } from '../../../../utils/TooltipContent';
import { correctDate, isEmpty, showErrorMessage, sortingString, toBoolean, toNumber } from '../../../../utils/utils';
import { ARAgrofertEditComponent } from '../common/agrofert-edit.component';
import { ARFertilizerEditComponent } from '../common/fertilizer-edit.component';
import { ARVerseSimpEditComponent } from '../common/verse-simp-edit.component';
import { ARVraEditComponent } from '../common/vra-edit.component';
import { ARBleUtils } from './ble.utils';
import { TranslatePipe, TranslateWithPunctuationPipe, TranslateDatePipe } from '../../../../pipes/translate.pipe';
import { SafePipe } from '../../../../pipes/safe.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  standalone: true,
  selector: 'ar-ble-orderItem-edit',
  templateUrl: 'orderItem-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ARAgrofertEditComponent, Tooltip, TooltipContent, ARVraEditComponent, ARFertilizerEditComponent, PreventDoubleClickDirective, ARVerseSimpEditComponent, CampaignYearPipe, CapitalizePipe, TranslatePipe, TranslateWithPunctuationPipe, SafePipe, TranslateDatePipe, CommonModule, FormsModule, BsDatepickerModule, TooltipModule],
  providers: [ARBleService, ParcelService, UserService, BeApiService],
})
export class ARBleOrderItemEditComponent implements OnInit, OnDestroy {
  @Input() orderItem: ARBleOrderItem;
  @Output() close = new EventEmitter();

  // on utilise @ViewChildren : car pas obligatoire initialisé (ngIf)
  @ViewChildren('fertilizerEditT1', { read: ARFertilizerEditComponent })
  fertilizerEditT1Ref: QueryList<ARFertilizerEditComponent>;
  @ViewChildren('fertilizerEditT2', { read: ARFertilizerEditComponent })
  fertilizerEditT2Ref: QueryList<ARFertilizerEditComponent>;
  @ViewChildren('fertilizerEditT3', { read: ARFertilizerEditComponent })
  fertilizerEditT3Ref: QueryList<ARFertilizerEditComponent>;
  @ViewChildren('fertilizerEditDn', { read: ARFertilizerEditComponent })
  fertilizerEditDnRef: QueryList<ARFertilizerEditComponent>;
  @ViewChildren('vraEditT1', { read: ARVraEditComponent }) vraEditT1Ref: QueryList<ARVraEditComponent>;
  @ViewChildren('vraEditT2', { read: ARVraEditComponent }) vraEditT2Ref: QueryList<ARVraEditComponent>;
  @ViewChildren('vraEditT3', { read: ARVraEditComponent }) vraEditT3Ref: QueryList<ARVraEditComponent>;
  @ViewChildren('vraEditDn', { read: ARVraEditComponent }) vraEditDnRef: QueryList<ARVraEditComponent>;

  error: any;
  sub: any;

  edited = false;
  withinOrder = false;

  orderItemId: number;
  parcel: ARBleParcel;

  azoteProductTypes: ARBleAzoteProductType[];

  t1FertilizerData: ARFertilizerData;
  t1VraData: ARVraData;
  t2FertilizerData: ARFertilizerData;
  t2VraData: ARVraData;
  t3FertilizerData: ARFertilizerData;
  t3VraData: ARVraData;
  dnFertilizerData: ARFertilizerData;
  dnVraData: ARVraData;

  currentCampaign: ARBleCampaign;
  isT3OrderCurrentlyOpen = false;
  isT2OrderCurrentlyOpen = false;
  isT1OrderCurrentlyOpen = false;
  // 2N pris de t3 (DFE)

  isT3DataHasStarted = false;
  isT3DataCurrentlyOpen = false;
  isT2DataCurrentlyOpen = false;
  isT1DataCurrentlyOpen = false;

  isT1OrderPassedWarning = false;
  isT2OrderPassedWarning = false;
  isT3OrderPassedWarning = false;

  productTypesIndex = new Map<number, string>();
  frequenciesIndex = new Map<number, string>();
  consoleModulationTypesIndex = new Map<number, string>();
  orderTypesIndex = new Map<string, ARBleOrderType>();

  tooltipTexts = TOOLTIP_TEXTS;

  private adviceTypeLockThresholdMs = 3 * 24 * 60 * 60 * 1000;
  isAdviceTypeLocked = false;

  commonConsoleModulationType: ARConsoleModulationType;

  isBatch = false;
  batchOrderItems: ARBleOrderItem[];
  cbBatchEdit: Object = {};
  cbBatchEditT1: Object = {};
  cbBatchEditT2: Object = {};
  cbBatchEditT3: Object = {};
  cbBatchEditDn: Object = {};
  hasT1Changed = false;
  hasT2Changed = false;
  hasT3Changed = false;
  hasDnChanged = false;

  canSpecyBeOrderedVerse = true;

  numPassages: number;
  lastPassage: string;
  // composantes de l'orderType
  hasT1: boolean;
  hasT2: boolean;
  hasT3: boolean;
  hasDn: boolean;
  hasT3Tn: boolean;
  hasT3Dfe: boolean;
  hasZonage: boolean;

  isAdmin: boolean = false;

  isT3LastAzoteAlreadySpreadDateCollapsed: boolean = false;

  showBeApi = false;
  hasBeApi = false;

  // Dn aussi
  t1t2t3Links = new Map<string, boolean>();

  orgaCanPFF = [];
  // possibilité de voir la partie PPF dans commandes sur AR

  seePFF: boolean = false;
  seeFallow: boolean = null;
  constructor(
    private bleService: ARBleService,
    private parcelService: ParcelService,
    private bleListService: ARBleListsService,
    private commonListsService: ARCommonListsService,
    private beApiService: BeApiService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
  ) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
  }

  ngOnInit() {
    const obsLists = this.bleListService.getListTypes(
      ARBleListType,
      ARBleListType.BLE_AZOTE_PRODUCT_TYPES,
      ARBleListType.BLE_AZOTE_FREQUENCIES,
      ARBleListType.BLE_ORDER_TYPES,
    );
    const obsLists2 = this.commonListsService.getListTypes(ARCommonListType, ARCommonListType.CONSOLE_MODULATION_TYPES);

    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[4].path === 'edit') {
        if (params['parcelId']) {
          const parcelId = +params['parcelId'];
          const obs0 = this.bleService.getParcel(parcelId);
          const obs1 = this.beApiService.getOrderItemByParcel(parcelId);

          forkJoin(obs0, obs1).subscribe((data: any) => {
            const baOI = data[1];
            if (baOI) {
              this.hasBeApi = baOI.hasBeApi;
            }

            this.getOrganisation().subscribe((organisation) => {
              this.handleShowBeApi(organisation);
            });

            const parcel = data[0];

            this.canSpecyBeOrderedVerse = this.canHandleVerse(parcel);
            if (parcel.orderItem) {
              this.orderItemId = parcel.orderItem.id;
              this.edited = true;
              const obs1 = this.bleService.getOrderItem(this.orderItemId);
              const obs2 = this.bleService.getCampaigns();
              forkJoin(obs1, obs2, obsLists, obsLists2).subscribe(
                (data: any) => {
                  const orderItem = data[0];
                  const campaigns = data[1];
                  this.orderItem = orderItem;
                  this.parcel = orderItem.parcel;
                  if (orderItem.hasResult && !this.isAdmin) {
                    this.seeFallow = true;
                  }

                  this.handleCampaigns(campaigns);
                  this.handleLists(data[2], data[3]);
                  this.checkCampaignConfigurationDates();
                  this.prepareOrderItem();
                },
                (e) => this.handleGetError(e),
              );
            } else {
              this.parcel = parcel;
              this.edited = false;
              this.newOrderItem(parcelId);
              const obs2 = this.bleService.getCampaigns();
              forkJoin(obs2, obsLists, obsLists2).subscribe((data: any) => {
                const campaigns = data[0];
                this.handleCampaigns(campaigns);
                // besoin des listes pour la validation
                this.handleLists(data[1], data[2]);
              });
            }
          });
        } else {
          showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.pasDeParcelle')).then((r) => {
            this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
          });
        }
      } else if (this.route.snapshot.url[4].path === 'batch') {
        // pas de BeApi en mode batch : de toute façon pas éditable

        this.isBatch = true;
        this.edited = true;
        const parcelIds = params['parcelIds'].split('-').map((x: string) => +x);

        forkJoin(obsLists, obsLists2).subscribe((data: any) => {
          this.handleLists(data[0], data[1]);

          // FIXME faire plutôt un callback de getBatchOrderItems
          let i = 0;
          while (i < parcelIds.length && this.canSpecyBeOrderedVerse) {
            const obs0 = this.bleService.getParcel(parcelIds[i]);
            obs0.subscribe((x: ARBleParcel) => {
              if (!this.canHandleVerse(x)) {
                this.canSpecyBeOrderedVerse = false;
              }
            });
            i++;
          }

          getBatchOrderItems(
            this.parcelService,
            this.bleService,
            parcelIds,
            this,
            'ARBle',
            () => {
              return new ARBleOrderItem();
            },
            () => {
              return new ARBleParcel();
            },
            ['azote', 'ble'],
            () => {
              this.getCampaignsBatch();
              this.cbBatchEditT1 = new CbBatchEditT1(this.cbBatchEdit);
              this.cbBatchEditT2 = new CbBatchEditT2(this.cbBatchEdit);
              this.cbBatchEditT3 = new CbBatchEditT3(this.cbBatchEdit);
              this.cbBatchEditDn = new CbBatchEditDn(this.cbBatchEdit);
            },
          );
        });
      }
    });
  }

  canHandleVerse(parcel: ARBleParcel) {
    // pas ble printemps (dur ou tendre)
    return parcel.specy.id != 3 && parcel.specy.id != 17;
  }

  getCampaignsBatch() {
    this.bleService.getCampaigns().subscribe((campaigns) => {
      this.handleCampaigns(campaigns);
      this.checkCampaignConfigurationDates();
    });
  }

  goBack(savedConfig: ARBleOrderItem = null) {
    this.close.emit(savedConfig);
    this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
    return false;
  }

  save() {
    try {
      // FIXME genérique pour t1 t2 et t3

      // on nettoie sinon .id = null pas valide sur le serveur
      // pas toujours initialisé (fait dans var-edit et fertilizer-edit)
      let restoreT1ConsoleModulationType = false;
      let restoreT1ConsoleFormatType = false;
      let restoreT1ConsoleVersion = false;
      let restoreT1ConsoleType = false;
      let restoreT1FertilizerType = false;
      if (this.orderItem.t1ConsoleModulationType && !this.orderItem.t1ConsoleModulationType.id) {
        restoreT1ConsoleModulationType = true;
        this.orderItem.t1ConsoleModulationType = null;
      }
      if (this.orderItem.t1ConsoleFormatType && !this.orderItem.t1ConsoleFormatType.id) {
        restoreT1ConsoleFormatType = true;
        this.orderItem.t1ConsoleFormatType = null;
      }
      if (this.orderItem.t1ConsoleVersion && !this.orderItem.t1ConsoleVersion.id) {
        restoreT1ConsoleVersion = true;
        this.orderItem.t1ConsoleVersion = null;
      }
      if (this.orderItem.t1ConsoleType && !this.orderItem.t1ConsoleType.id) {
        restoreT1ConsoleType = true;
        this.orderItem.t1ConsoleType = null;
      }
      if (this.orderItem.t1FertilizerType && !this.orderItem.t1FertilizerType.id) {
        restoreT1FertilizerType = true;
        this.orderItem.t1FertilizerType = null;
      }

      let restoreT2ConsoleModulationType = false;
      let restoreT2ConsoleFormatType = false;
      let restoreT2ConsoleVersion = false;
      let restoreT2ConsoleType = false;
      let restoreT2FertilizerType = false;
      if (this.orderItem.t2ConsoleModulationType && !this.orderItem.t2ConsoleModulationType.id) {
        restoreT2ConsoleModulationType = true;
        this.orderItem.t2ConsoleModulationType = null;
      }
      if (this.orderItem.t2ConsoleFormatType && !this.orderItem.t2ConsoleFormatType.id) {
        restoreT2ConsoleFormatType = true;
        this.orderItem.t2ConsoleFormatType = null;
      }
      if (this.orderItem.t2ConsoleVersion && !this.orderItem.t2ConsoleVersion.id) {
        restoreT2ConsoleVersion = true;
        this.orderItem.t2ConsoleVersion = null;
      }
      if (this.orderItem.t2ConsoleType && !this.orderItem.t2ConsoleType.id) {
        restoreT2ConsoleType = true;
        this.orderItem.t2ConsoleType = null;
      }
      if (this.orderItem.t2FertilizerType && !this.orderItem.t2FertilizerType.id) {
        restoreT2FertilizerType = true;
        this.orderItem.t2FertilizerType = null;
      }

      let restoreDnConsoleModulationType = false;
      let restoreDnConsoleFormatType = false;
      let restoreDnConsoleVersion = false;
      let restoreDnConsoleType = false;
      let restoreDnFertilizerType = false;
      if (this.orderItem.dnConsoleModulationType && !this.orderItem.dnConsoleModulationType.id) {
        restoreDnConsoleModulationType = true;
        this.orderItem.dnConsoleModulationType = null;
      }
      if (this.orderItem.dnConsoleFormatType && !this.orderItem.dnConsoleFormatType.id) {
        restoreDnConsoleFormatType = true;
        this.orderItem.dnConsoleFormatType = null;
      }
      if (this.orderItem.dnConsoleVersion && !this.orderItem.dnConsoleVersion.id) {
        restoreDnConsoleVersion = true;
        this.orderItem.dnConsoleVersion = null;
      }
      if (this.orderItem.dnConsoleType && !this.orderItem.dnConsoleType.id) {
        restoreDnConsoleType = true;
        this.orderItem.dnConsoleType = null;
      }
      if (this.orderItem.dnFertilizerType && !this.orderItem.dnFertilizerType.id) {
        restoreDnFertilizerType = true;
        this.orderItem.dnFertilizerType = null;
      }

      // pas toujours initialisées (fait dans vra-edit et fertilizer-edit,
      // qui peut ne pas être initée pour T3
      let restoreT3ConsoleModulationType = false;
      let restoreT3ConsoleFormatType = false;
      let restoreT3ConsoleVersion = false;
      let restoreT3ConsoleType = false;
      let restoreT3FertilizerType = false;
      if (this.orderItem.t3ConsoleModulationType && !this.orderItem.t3ConsoleModulationType.id) {
        restoreT3ConsoleModulationType = true;
        this.orderItem.t3ConsoleModulationType = null;
      }
      if (this.orderItem.t3ConsoleFormatType && !this.orderItem.t3ConsoleFormatType.id) {
        restoreT3ConsoleFormatType = true;
        this.orderItem.t3ConsoleFormatType = null;
      }
      if (this.orderItem.t3ConsoleVersion && !this.orderItem.t3ConsoleVersion.id) {
        restoreT3ConsoleVersion = true;
        this.orderItem.t3ConsoleVersion = null;
      }
      if (this.orderItem.t3ConsoleType && !this.orderItem.t3ConsoleType.id) {
        restoreT3ConsoleType = true;
        this.orderItem.t3ConsoleType = null;
      }
      if (this.orderItem.t3FertilizerType && !this.orderItem.t3FertilizerType.id) {
        restoreT3FertilizerType = true;
        this.orderItem.t3FertilizerType = null;
      }

      if (this.orderItem.t3LastAzoteAlreadySpreadDate) {
        this.orderItem.t3LastAzoteAlreadySpreadDate = correctDate(<Date>this.orderItem.t3LastAzoteAlreadySpreadDate);
      }

      let restoreOrderType = false;
      if (this.orderItem.orderType && !this.orderItem.orderType.id) {
        restoreOrderType = true;
        this.orderItem.orderType = null;
      }

      let restorePastAzoteFrequency = false;
      if (this.orderItem.pastAzoteFrequency && !this.orderItem.pastAzoteFrequency.id) {
        restorePastAzoteFrequency = true;
        this.orderItem.pastAzoteFrequency = null;
      }
      let restoreVerseApportMoAutomne = false;
      if (this.orderItem.verseApportMoAutomne && !this.orderItem.verseApportMoAutomne.id) {
        restoreVerseApportMoAutomne = true;
        this.orderItem.verseApportMoAutomne = null;
      }
      let restoreVerseApportsMinerauxFractionnement = false;
      if (this.orderItem.verseApportsMinerauxFractionnement && !this.orderItem.verseApportsMinerauxFractionnement.id) {
        restoreVerseApportsMinerauxFractionnement = true;
        this.orderItem.verseApportsMinerauxFractionnement = null;
      }

      // TODO supprim champs agrofert
      let restoreEtatVegetatifSh = false;
      if (this.orderItem.etatVegetatifSh && !this.orderItem.etatVegetatifSh.id) {
        restoreEtatVegetatifSh = true;
        this.orderItem.etatVegetatifSh = null;
      }
      let restoreFirstAzoteProductType = false;
      if (this.orderItem.firstAzoteProductType && !this.orderItem.firstAzoteProductType.id) {
        restoreFirstAzoteProductType = true;
        this.orderItem.firstAzoteProductType = null;
      }
      let restoreFirstAzotePeriod = false;
      if (this.orderItem.firstAzotePeriod && !this.orderItem.firstAzotePeriod.id) {
        restoreFirstAzotePeriod = true;
        this.orderItem.firstAzotePeriod = null;
      }
      let restoreSecondAzoteProductType = false;
      if (this.orderItem.secondAzoteProductType && !this.orderItem.secondAzoteProductType.id) {
        restoreSecondAzoteProductType = true;
        this.orderItem.secondAzoteProductType = null;
      }
      let restoreSecondAzotePeriod = false;
      if (this.orderItem.secondAzotePeriod && !this.orderItem.secondAzotePeriod.id) {
        restoreSecondAzotePeriod = true;
        this.orderItem.secondAzotePeriod = null;
      }
      let restorePastAzoteProductType = false;
      if (this.orderItem.pastAzoteProductType && !this.orderItem.pastAzoteProductType.id) {
        restorePastAzoteProductType = true;
        this.orderItem.pastAzoteProductType = null;
      }
      let restorePastAzotePreviousCultureProductType = false;
      if (
        this.orderItem.pastAzotePreviousCultureProductType &&
        !this.orderItem.pastAzotePreviousCultureProductType.id
      ) {
        restorePastAzotePreviousCultureProductType = true;
        this.orderItem.pastAzotePreviousCultureProductType = null;
      }
      let restorePastResiduType = false;
      if (this.orderItem.pastResiduType && !this.orderItem.pastResiduType.id) {
        restorePastResiduType = true;
        this.orderItem.pastResiduType = null;
      }
      let restorePrairieAge = false;
      if (this.orderItem.prairieAge && !this.orderItem.prairieAge.id) {
        restorePrairieAge = true;
        this.orderItem.prairieAge = null;
      }
      let restorePrairieDestructionPeriod = false;
      if (this.orderItem.prairieDestructionPeriod && !this.orderItem.prairieDestructionPeriod.id) {
        restorePrairieDestructionPeriod = true;
        this.orderItem.prairieDestructionPeriod = null;
      }
      let restorePrairiePostDestructionRank = false;
      if (this.orderItem.prairiePostDestructionRank && !this.orderItem.prairiePostDestructionRank.id) {
        restorePrairiePostDestructionRank = true;
        this.orderItem.prairiePostDestructionRank = null;
      }
      let restorePrairieExploitationMode = false;
      if (this.orderItem.prairieExploitationMode && !this.orderItem.prairieExploitationMode.id) {
        restorePrairieExploitationMode = true;
        this.orderItem.prairieExploitationMode = null;
      }
      let restorePrairieType = false;
      if (this.orderItem.prairieType && !this.orderItem.prairieType.id) {
        restorePrairieType = true;
        this.orderItem.prairieType = null;
      }
      let restoreCIType = false;
      if (this.orderItem.ciType && !this.orderItem.ciType.id) {
        restoreCIType = true;
        this.orderItem.ciType = null;
      }
      let restoreCIDevelopment = false;
      if (this.orderItem.ciDevelopment && !this.orderItem.ciDevelopment.id) {
        restoreCIDevelopment = true;
        this.orderItem.ciDevelopment = null;
      }
      let restoreCIDestructionPeriod = false;
      if (this.orderItem.ciDestructionPeriod && !this.orderItem.ciDestructionPeriod.id) {
        restoreCIDestructionPeriod = true;
        this.orderItem.ciDestructionPeriod = null;
      }

      try {
        this.orderItem.objective = toNumber(this.orderItem.objective);
        this.orderItem.reliquatSh = toNumber(this.orderItem.reliquatSh);
        this.orderItem.firstAzoteConcentration = toNumber(this.orderItem.firstAzoteConcentration);
        this.orderItem.firstAzoteDensity = toNumber(this.orderItem.firstAzoteDensity);
        this.orderItem.secondAzoteConcentration = toNumber(this.orderItem.secondAzoteConcentration);
        this.orderItem.secondAzoteDensity = toNumber(this.orderItem.secondAzoteDensity);
        this.orderItem.pastAzotePreviousCultureConcentration = toNumber(
          this.orderItem.pastAzotePreviousCultureConcentration,
        );
        this.orderItem.pastAzotePreviousCultureDensity = toNumber(this.orderItem.pastAzotePreviousCultureDensity);
        this.orderItem.t1FertilizerConcentration = toNumber(this.orderItem.t1FertilizerConcentration);
        this.orderItem.t2FertilizerConcentration = toNumber(this.orderItem.t2FertilizerConcentration);
        this.orderItem.dnFertilizerConcentration = toNumber(this.orderItem.dnFertilizerConcentration);
        this.orderItem.t3FertilizerConcentration = toNumber(this.orderItem.t3FertilizerConcentration);
      } catch (e) {
        // TODO détails plus précis ?
        showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.invalidNumber'));
        return;
      }

      // traitement du cas pas zonage: valeurs par défaut pour les données
      // fertiliseur
      // FIXME vraiment nécessaire ??? valeurs bidons ; vérifier
      if (!this.hasZonage) {
        // s'applique à tous les passages
        this.orderItem.t1FertilizerType = new ARFertilizerType();
        // Solide
        this.orderItem.t1FertilizerType.id = 1;
        this.orderItem.t1FertilizerConcentration = 33.5;
        this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
        // Aucune
        this.orderItem.t1ConsoleModulationType.id = 1;

        this.orderItem.t2FertilizerType = new ARFertilizerType();
        // Solide
        this.orderItem.t2FertilizerType.id = 1;
        this.orderItem.t2FertilizerConcentration = 33.5;
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        // Aucune
        this.orderItem.t2ConsoleModulationType.id = 1;

        this.orderItem.dnFertilizerType = new ARFertilizerType();
        // Solide
        this.orderItem.dnFertilizerType.id = 1;
        this.orderItem.dnFertilizerConcentration = 33.5;
        this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
        // Aucune
        this.orderItem.dnConsoleModulationType.id = 1;

        this.orderItem.t3FertilizerType = new ARFertilizerType();
        // Solide
        this.orderItem.t3FertilizerType.id = 1;
        this.orderItem.t3FertilizerConcentration = 33.5;
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        // Aucune
        this.orderItem.t3ConsoleModulationType.id = 1;

        if (this.isBatch) {
          // pour que les champs soient pris en compte pour le batch
          (<any>this.cbBatchEdit)['t1FertilizerType'] = true;
          (<any>this.cbBatchEdit)['t1FertilizerConcentration'] = true;
          (<any>this.cbBatchEdit)['t1ConsoleModulationType'] = true;

          (<any>this.cbBatchEdit)['t2FertilizerType'] = true;
          (<any>this.cbBatchEdit)['t2FertilizerConcentration'] = true;
          (<any>this.cbBatchEdit)['t2ConsoleModulationType'] = true;

          (<any>this.cbBatchEdit)['dnFertilizerType'] = true;
          (<any>this.cbBatchEdit)['dnFertilizerConcentration'] = true;
          (<any>this.cbBatchEdit)['dnConsoleModulationType'] = true;

          (<any>this.cbBatchEdit)['t3FertilizerType'] = true;
          (<any>this.cbBatchEdit)['t3FertilizerConcentration'] = true;
          (<any>this.cbBatchEdit)['t3ConsoleModulationType'] = true;
        }
      }

      if (this.isBatch) {
        // FIXME  Voir comment est traité l'order type pour batch Colza et reproduire
        const obss: Observable<ARBleOrderItem>[] = [];
        prepareBatchSave(this.orderItem, this.batchOrderItems, this.cbBatchEdit).forEach(
          (batchOrderItem: ARBleOrderItem) => {
            // si clic sur has3Passages has2Passages ou has1Passage, on considère ça comme une volonté d'éditer par lot
            // avec l'état du radio comme valeur pour ces champs
            // sinon on ne touche pas à la valeur de orderType
            // sauf dans le cas d'un nouveau orderItem
            if ((<any>this.cbBatchEdit)['orderType'] || !batchOrderItem.id) {
              // recopie
              batchOrderItem.orderType = this.orderItem.orderType;

              // FIXME changer le batch => faire un wizard
              // TODO ancien commentaire : toujours valide ?
              // setter le T2 et T3 (doivent obligatoirement remplis et pas null)
              // mais checkbox edition lot confondue avec valeur
              // quand null => false
              // TODO changer le nom car cbBatchEdit ne correspond pas vraiment
              // TODO la valeur est prise pour hasT2 (donc même si False, considéré
              // TODO comme la valeur pour hasT2 de tous les items du batch)
              // TODO alors que pour les autres champs, si False, pas de maj de la valeur

              if (!this.hasT1) {
                this.prepareNewT1Data(batchOrderItem);
              }
              if (!this.hasT2) {
                this.prepareNewT2Data(batchOrderItem);
              }
              if (!this.hasDn) {
                this.prepareNewDnData(batchOrderItem);
              }
              if (!this.hasT3) {
                this.prepareNewT3Data(batchOrderItem);
              }
            }

            if ((<any>this.cbBatchEdit)['consoleModulationType']) {
              // identique : si pas hasT1 ou ... rempli quand même mais pas d'importance
              batchOrderItem.t1ConsoleModulationType = this.commonConsoleModulationType;
              batchOrderItem.t2ConsoleModulationType = this.commonConsoleModulationType;
              batchOrderItem.dnConsoleModulationType = this.commonConsoleModulationType;
              batchOrderItem.t3ConsoleModulationType = this.commonConsoleModulationType;
            }

            obss.push(this.bleService.saveOrderItem(batchOrderItem));
          },
        );

        // l'un après l'autre : goback a la
        concat(...obss)
          .pipe(toArray())
          .subscribe(
            (orderItems) => {
              this.goBack();
            },
            (error) => this.handleSavebatchError(error),
          );
      } else {
        this.bleService.saveOrderItem(this.orderItem).subscribe(
          (orderItem) => {
            if (!this.withinOrder) {
              this.goBack(orderItem);
            } else {
              this.confirmOrder(orderItem.parcel.id);
            }
          },
          (error) => this.handleSaveError(error),
        );
      }

      if (restoreT1ConsoleModulationType) {
        this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t1ConsoleModulationType.id = null;
      }
      if (restoreT1ConsoleFormatType) {
        this.orderItem.t1ConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.t1ConsoleFormatType.id = null;
      }
      if (restoreT1ConsoleVersion) {
        this.orderItem.t1ConsoleVersion = new ARConsoleVersion();
        this.orderItem.t1ConsoleVersion.id = null;
      }
      if (restoreT1ConsoleType) {
        this.orderItem.t1ConsoleType = new ARConsoleType();
        this.orderItem.t1ConsoleType.id = null;
      }
      if (restoreT1FertilizerType) {
        this.orderItem.t1FertilizerType = new ARFertilizerType();
        this.orderItem.t1FertilizerType.id = null;
      }

      if (restoreT2ConsoleModulationType) {
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t2ConsoleModulationType.id = null;
      }
      if (restoreT2ConsoleFormatType) {
        this.orderItem.t2ConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.t2ConsoleFormatType.id = null;
      }
      if (restoreT2ConsoleVersion) {
        this.orderItem.t2ConsoleVersion = new ARConsoleVersion();
        this.orderItem.t2ConsoleVersion.id = null;
      }
      if (restoreT2ConsoleType) {
        this.orderItem.t2ConsoleType = new ARConsoleType();
        this.orderItem.t2ConsoleType.id = null;
      }
      if (restoreT2FertilizerType) {
        this.orderItem.t2FertilizerType = new ARFertilizerType();
        this.orderItem.t2FertilizerType.id = null;
      }

      if (restoreDnConsoleModulationType) {
        this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.dnConsoleModulationType.id = null;
      }
      if (restoreDnConsoleFormatType) {
        this.orderItem.dnConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.dnConsoleFormatType.id = null;
      }
      if (restoreDnConsoleVersion) {
        this.orderItem.dnConsoleVersion = new ARConsoleVersion();
        this.orderItem.dnConsoleVersion.id = null;
      }
      if (restoreDnConsoleType) {
        this.orderItem.dnConsoleType = new ARConsoleType();
        this.orderItem.dnConsoleType.id = null;
      }
      if (restoreDnFertilizerType) {
        this.orderItem.dnFertilizerType = new ARFertilizerType();
        this.orderItem.dnFertilizerType.id = null;
      }

      if (restoreT3ConsoleModulationType) {
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t3ConsoleModulationType.id = null;
      }
      if (restoreT3ConsoleFormatType) {
        this.orderItem.t3ConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.t3ConsoleFormatType.id = null;
      }
      if (restoreT3ConsoleVersion) {
        this.orderItem.t3ConsoleVersion = new ARConsoleVersion();
        this.orderItem.t3ConsoleVersion.id = null;
      }
      if (restoreT3ConsoleType) {
        this.orderItem.t3ConsoleType = new ARConsoleType();
        this.orderItem.t3ConsoleType.id = null;
      }
      if (restoreT3FertilizerType) {
        this.orderItem.t3FertilizerType = new ARFertilizerType();
        this.orderItem.t3FertilizerType.id = null;
      }

      if (restoreOrderType) {
        this.orderItem.orderType = new ARBleOrderType();
        this.orderItem.orderType.id = null;
      }

      if (restorePastAzoteFrequency) {
        this.orderItem.pastAzoteFrequency = new ARBleAzoteFrequency();
        this.orderItem.pastAzoteFrequency.id = null;
      }

      if (restoreVerseApportMoAutomne) {
        this.orderItem.verseApportMoAutomne = new ARVerseApportMoAutomne();
        this.orderItem.verseApportMoAutomne.id = null;
      }

      if (restoreVerseApportsMinerauxFractionnement) {
        this.orderItem.verseApportsMinerauxFractionnement = new ARVerseApportsMinerauxFractionnement();
        this.orderItem.verseApportsMinerauxFractionnement.id = null;
      }

      // TODO suppr champs agrofert
      if (restoreEtatVegetatifSh) {
        this.orderItem.etatVegetatifSh = new ARBleEtatVegetatifSh();
        this.orderItem.etatVegetatifSh.id = null;
      }
      if (restoreFirstAzoteProductType) {
        this.orderItem.firstAzoteProductType = new ARBleAzoteProductType();
        this.orderItem.firstAzoteProductType.id = null;
      }
      if (restoreFirstAzotePeriod) {
        this.orderItem.firstAzotePeriod = new ARBleAzotePeriod();
        this.orderItem.firstAzotePeriod.id = null;
      }
      if (restoreSecondAzoteProductType) {
        this.orderItem.secondAzoteProductType = new ARBleAzoteProductType();
        this.orderItem.secondAzoteProductType.id = null;
      }
      if (restoreSecondAzotePeriod) {
        this.orderItem.secondAzotePeriod = new ARBleAzotePeriod();
        this.orderItem.secondAzotePeriod.id = null;
      }
      if (restorePastAzoteProductType) {
        this.orderItem.pastAzoteProductType = new ARBleAzoteProductType();
        this.orderItem.pastAzoteProductType.id = null;
      }
      if (restorePastAzotePreviousCultureProductType) {
        this.orderItem.pastAzotePreviousCultureProductType = new ARBleAzoteProductType();
        this.orderItem.pastAzotePreviousCultureProductType.id = null;
      }
      if (restorePastResiduType) {
        this.orderItem.pastResiduType = new ARBlePastResiduType();
        this.orderItem.pastResiduType.id = null;
      }
      if (restorePrairieAge) {
        this.orderItem.prairieAge = new ARBlePrairieAge();
        this.orderItem.prairieAge.id = null;
      }
      if (restorePrairieDestructionPeriod) {
        this.orderItem.prairieDestructionPeriod = new ARBlePrairieDestructionPeriod();
        this.orderItem.prairieDestructionPeriod.id = null;
      }
      if (restorePrairiePostDestructionRank) {
        this.orderItem.prairiePostDestructionRank = new ARBlePrairiePostDestructionRank();
        this.orderItem.prairiePostDestructionRank.id = null;
      }
      if (restorePrairieExploitationMode) {
        this.orderItem.prairieExploitationMode = new ARBlePrairieExploitationMode();
        this.orderItem.prairieExploitationMode.id = null;
      }
      if (restorePrairieType) {
        this.orderItem.prairieType = new ARBlePrairieType();
        this.orderItem.prairieType.id = null;
      }
      if (restoreCIType) {
        this.orderItem.ciType = new ARBleCIType();
        this.orderItem.ciType.id = null;
      }
      if (restoreCIDevelopment) {
        this.orderItem.ciDevelopment = new ARBleCIDevelopment();
        this.orderItem.ciDevelopment.id = null;
      }
      if (restoreCIDestructionPeriod) {
        this.orderItem.ciDestructionPeriod = new ARBleCIDestructionPeriod();
        this.orderItem.ciDestructionPeriod.id = null;
      }
    } catch (e) {
      // TODO changer ce texte
      console.error(e);
      showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.internal'));
    }
  }

  getParcel(parcelId: number) {
    this.bleService.getParcel(parcelId).subscribe(
      (parcel) => {
        this.parcel = parcel;
      },
      (error) => this.handleGetError(error),
    );
  }

  getCampaigns() {
    this.bleService.getCampaigns().subscribe((data) => {
      this.handleCampaigns(data);
    });
  }

  // FIXME récupérer la campagne avec la parcelle (au lieu de séparément)
  handleCampaigns(data: ARBleCampaign[]) {
    const campaigns = data.filter((x) => ARBleUtils.isCampaignCurrentlyOpen(x));
    if (this.isBatch) {
      // on suppose qu'on est dans la dernière campagne
      // TODO  vérifier avec les parcelles; normalement pas éditable sinon
      if (campaigns.length > 0) {
        this.currentCampaign = campaigns[0];
      }
    } else {
      for (const campaign of campaigns) {
        if (campaign.id === this.parcel.campaign.id) {
          // FIXME gérer la campagne de la parcelle en cours d'édition
          this.currentCampaign = campaign;
        }
      }
    }

    if (this.currentCampaign) {
      this.isT1OrderCurrentlyOpen = ARBleUtils.isT1OrderCurrentlyOpen(this.currentCampaign);
      this.isT2OrderCurrentlyOpen = ARBleUtils.isT2OrderCurrentlyOpen(this.currentCampaign);
      this.isT3OrderCurrentlyOpen = ARBleUtils.isT3OrderCurrentlyOpen(this.currentCampaign);

      this.isT1DataCurrentlyOpen = ARBleUtils.isT1DataCurrentlyOpen(this.currentCampaign);
      this.isT2DataCurrentlyOpen = ARBleUtils.isT2DataCurrentlyOpen(this.currentCampaign);
      this.isT3DataHasStarted = ARBleUtils.isT3DataHasStarted(this.currentCampaign);
      this.isT3DataCurrentlyOpen = ARBleUtils.isT3DataCurrentlyOpen(this.currentCampaign);
    }
  }

  checkCampaignConfigurationDates() {
    if (!this.isBatch) {
      if (!!this.currentCampaign && !this.orderItem.order) {
        // reset les passages pas encore commandés
        // et commande plus possible
        if (this.hasT1 && !this.isT1OrderCurrentlyOpen) {
          this.hasT1 = false;
          this.prepareNewT1Data();
          this.isT1OrderPassedWarning = true;
        }
        if (this.hasT2 && !this.isT2OrderCurrentlyOpen) {
          this.hasT2 = false;
          this.prepareNewT2Data();
          this.isT2OrderPassedWarning = true;
        }

        // 2N => commandés obligatoirement avec _T1_ (qui est le premier) => si T1 plus ouvert
        // DN doit être enlevé aussi
        if (this.hasDn && !this.isT1OrderCurrentlyOpen) {
          this.hasDn = false;
          this.prepareNewDnData();
        }

        if (this.hasT3 && !this.isT3OrderCurrentlyOpen) {
          this.hasT3 = false;
          this.prepareNewT3Data();
          this.isT3OrderPassedWarning = true;
        }
      }
    }
  }

  handleLists(bleLists: Map<ARBleListType, ListItem[]>, commonLists: Map<ARCommonListType, ListItem[]>) {
    const azoteProductTypes = bleLists.get(ARBleListType.BLE_AZOTE_PRODUCT_TYPES).sort(sortingString('label'));
    for (const p of azoteProductTypes) {
      this.productTypesIndex.set(p.id, p.code);
    }

    const pastAzoteFrequencies = bleLists.get(ARBleListType.BLE_AZOTE_FREQUENCIES);
    for (const p of pastAzoteFrequencies) {
      this.frequenciesIndex.set(p.id, p.code);
    }

    const bleOrderTypes = bleLists.get(ARBleListType.BLE_ORDER_TYPES);
    for (const p of bleOrderTypes) {
      this.orderTypesIndex.set(p.code, p);
    }

    const consoleModulationTypes = commonLists.get(ARCommonListType.CONSOLE_MODULATION_TYPES);
    for (const p of consoleModulationTypes) {
      this.consoleModulationTypesIndex.set(p.id, p.code);
    }
  }

  newOrderItem(parcelId: number) {
    this.orderItem = new ARBleOrderItem();
    this.orderItem.parcel = new ARBleParcel();

    this.orderItem.parcel.id = parcelId;

    this.setupFromOrderType();

    this.orderItem.objective = null;

    this.prepareNewT1Data();
    this.prepareNewT2Data();
    this.prepareNewDnData();
    this.prepareNewT3Data();

    this.prepareFertilizerData();
    this.prepareVraData();
  }

  prepareNewT1Data(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t1AzoteToSpread = value;
    this.prepareNewT1ZonageData(orderItem);
    this.prepareNewT1FertilizerData(orderItem);
  }

  prepareNewT1ZonageData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t1ConsoleModulationType = value;
    orderItem.t1ConsoleFormatType = value;
    orderItem.t1ConsoleType = value;
    orderItem.t1ConsoleVersion = value;
    orderItem.t1OtherConsoleVersion = value;
  }

  prepareNewT1FertilizerData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t1FertilizerConcentration = value;
    orderItem.t1FertilizerType = value;
  }

  prepareNewT2Data(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t2AzoteToSpread = value;
    this.prepareNewT2ZonageData(orderItem);
    this.prepareNewT2FertilizerData(orderItem);
  }

  prepareNewT2ZonageData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t2ConsoleModulationType = value;
    orderItem.t2ConsoleFormatType = value;
    orderItem.t2ConsoleType = value;
    orderItem.t2ConsoleVersion = value;
    orderItem.t2OtherConsoleVersion = value;
  }

  prepareNewT2FertilizerData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t2FertilizerConcentration = value;
    orderItem.t2FertilizerType = value;
  }

  prepareNewDnData(orderItem: any = this.orderItem, value: any = null) {
    this.prepareNewDnZonageData(orderItem);
    this.prepareNewDnFertilizerData(orderItem);
  }

  prepareNewDnZonageData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.dnConsoleModulationType = value;
    orderItem.dnConsoleFormatType = value;
    orderItem.dnConsoleType = value;
    orderItem.dnConsoleVersion = value;
    orderItem.dnOtherConsoleVersion = value;
  }

  prepareNewDnFertilizerData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.dnFertilizerConcentration = value;
    orderItem.dnFertilizerType = value;
  }

  prepareNewT3Data(orderItem: any = this.orderItem, value: any = null) {
    // TODO vider aussi rendement et dose previsionnelle ?
    // TODO vider aussi agrifert ?
    orderItem.t3AzoteAlreadySpread = value;
    orderItem.t3LastAzoteAlreadySpread = value;
    orderItem.t3LastAzoteAlreadySpreadDate = value;
    this.prepareNewT3ZonageData(orderItem);
    this.prepareNewT3FertilizerData(orderItem);
  }

  prepareNewT3ZonageData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t3ConsoleModulationType = value;
    orderItem.t3ConsoleFormatType = value;
    orderItem.t3ConsoleType = value;
    orderItem.t3ConsoleVersion = value;
    orderItem.t3OtherConsoleVersion = value;
  }

  prepareNewT3FertilizerData(orderItem: any = this.orderItem, value: any = null) {
    orderItem.t3FertilizerConcentration = value;
    orderItem.t3FertilizerType = value;
  }

  prepareOrderItem() {
    this.prepareOrderType(true);
    // commune
    this.prepareConsoleModulationType();
    this.prepareFertilizerData();
    this.prepareVraData();
    this.computeAdviceTypeLock();
  }

  prepareFertilizerData() {
    this.t1FertilizerData = new ARFertilizerT1DataFacade(this.orderItem);
    this.t2FertilizerData = new ARFertilizerT2DataFacade(this.orderItem);
    this.t3FertilizerData = new ARFertilizerT3DataFacade(this.orderItem);
    this.dnFertilizerData = new ARFertilizerDnDataFacade(this.orderItem);
  }

  prepareVraData() {
    this.t1VraData = new ARVraT1DataFacade(this.orderItem);
    this.t2VraData = new ARVraT2DataFacade(this.orderItem);
    this.t3VraData = new ARVraT3DataFacade(this.orderItem);
    this.dnVraData = new ARVraDnDataFacade(this.orderItem);
  }

  private computeAdviceTypeLock(): void {
    if (this.isAdmin) {
      this.isAdviceTypeLocked = false;
      return;
    }

    const items = this.isBatch ? this.batchOrderItems : [this.orderItem];
    if (!items || items.length === 0) {
      this.isAdviceTypeLocked = false;
      return;
    }

    const dates = this.collectRestitutionDatesFromOrderItems(items);
    if (dates.length === 0) {
      this.isAdviceTypeLocked = false;
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.isAdviceTypeLocked = dates.some((date) => date.getTime() - today.getTime() < this.adviceTypeLockThresholdMs);
  }

  private collectRestitutionDatesFromOrderItems(items: ARBleOrderItem[]): Date[] {
    const dates: Date[] = [];

    items
      .filter((item) => !!item && !!item.order)
      .forEach((item) => {
        const campaignYear = this.getCampaignYearFromOrderItem(item);
        if (item.hasT1) {
          this.addRestitutionDate(dates, item.t1_date_livraison, item.defaultWeekT1, campaignYear);
        }
        if (item.hasT2) {
          this.addRestitutionDate(dates, item.t2_date_livraison, item.defaultWeekT2, campaignYear);
        }
        if (item.hasDn) {
          this.addRestitutionDate(dates, item.dn_date_livraison, item.defaultWeekDn, campaignYear);
        }
        if (item.hasT3) {
          this.addRestitutionDate(dates, item.t3_date_livraison, item.defaultWeekT3, campaignYear);
        }
      });

    return dates;
  }

  private addRestitutionDate(target: Date[], primary: Date, fallback: any, campaignYear: number): void {
    const normalizedPrimary = this.normalizeRestitutionDate(primary, campaignYear);
    if (normalizedPrimary) {
      target.push(normalizedPrimary);
      return;
    }

    const normalizedFallback = this.normalizeRestitutionDate(fallback, campaignYear);
    if (normalizedFallback) {
      target.push(normalizedFallback);
    }
  }

  private normalizeRestitutionDate(date: any, campaignYear?: number): Date {
    if (!date) {
      return null;
    }

    if (date instanceof Date) {
      const parsed = new Date(date.getTime());
      parsed.setHours(0, 0, 0, 0);
      const corrected = correctDate(parsed);
      corrected.setHours(0, 0, 0, 0);
      return corrected;
    }

    if (typeof date === 'string' || typeof date === 'number') {
      const parsed = new Date(date as any);
      if (isNaN(parsed.getTime())) {
        return null;
      }
      const corrected = correctDate(parsed);
      corrected.setHours(0, 0, 0, 0);
      return corrected;
    }

    if (typeof date === 'object') {
      const defaultWeekDate = this.normalizeDefaultWeek(date, campaignYear);
      if (defaultWeekDate) {
        return defaultWeekDate;
      }

      if (date.date) {
        return this.normalizeRestitutionDate(date.date, campaignYear);
      }

      return null;
    }

    return null;
  }

  private normalizeDefaultWeek(value: any, campaignYear?: number): Date {
    if (!value || typeof value.week === 'undefined') {
      return null;
    }

    const week = this.parseWeekNumber(value.week);
    if (!week || week <= 0) {
      return null;
    }

    let year = this.extractYearValue(campaignYear);
    if (!year) {
      year = this.extractYearValue(value.year);
    }

    if (!year) {
      return null;
    }

    const weekDate = this.getDateForIsoWeek(year, week);
    if (!weekDate) {
      return null;
    }

    const corrected = correctDate(weekDate);
    corrected.setHours(0, 0, 0, 0);
    return corrected;
  }

  private getDateForIsoWeek(year: number, week: number): Date {
    if (!year || !week || week < 1) {
      return null;
    }

    const januaryFourth = new Date(year, 0, 4);
    const januaryFourthDay = januaryFourth.getDay() || 7;
    const weekStart = new Date(januaryFourth.getTime());
    weekStart.setDate(januaryFourth.getDate() - januaryFourthDay + 1 + (week - 1) * 7);
    weekStart.setHours(0, 0, 0, 0);
    return weekStart;
  }

  private extractYearValue(value: any): number {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'number') {
      return isNaN(value) ? null : value;
    }

    if (value instanceof Date) {
      const copy = new Date(value.getTime());
      return isNaN(copy.getTime()) ? null : copy.getUTCFullYear();
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '') {
        return null;
      }

      const parsedDate = new Date(trimmed);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate.getUTCFullYear();
      }

      const numeric = parseInt(trimmed, 10);
      return isNaN(numeric) ? null : numeric;
    }

    if (typeof value === 'object') {
      if (typeof value.year !== 'undefined') {
        return this.extractYearValue(value.year);
      }
      if (typeof value.campaignYear !== 'undefined') {
        return this.extractYearValue(value.campaignYear);
      }
    }

    return null;
  }

  private parseWeekNumber(value: any): number {
    if (typeof value === 'number') {
      return isNaN(value) ? null : Math.floor(value);
    }
    if (typeof value === 'string') {
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  }

  private getCampaignYearFromOrderItem(orderItem: ARBleOrderItem): number {
    if (!orderItem || !orderItem.order || !orderItem.order.campaign) {
      return null;
    }

    const campaign = orderItem.order.campaign;

    let year = this.extractYearValue(campaign.campaignYear);
    if (!year) {
      year = this.extractYearValue(campaign.year);
    }

    if (!year) {
      year = this.extractYearValue(campaign.endingOn);
    }

    if (!year) {
      year = this.extractYearValue(campaign.startingOn);
    }

    if (!year && campaign.configuration) {
      const config = campaign.configuration;
      const candidates = [
        config.startingOn,
        config.orderT1EndingOn,
        config.dataT1EndingOn,
        config.orderT2EndingOn,
        config.dataT2EndingOn,
        config.dataT3StartingOn,
        config.orderT3EndingOn,
        config.dataT3EndingOn,
      ];

      for (const candidate of candidates) {
        year = this.extractYearValue(candidate);
        if (year) {
          break;
        }
      }
    }

    return year;
  }

  addOrder() {
    this.withinOrder = true;
    this.save();
  }

  confirmOrder(parcelId: number) {
    this.router.navigate(['/orders', 'azote', 'ble', 'orders', 'new', parcelId]);
  }

  isOrderDisabled() {
    // TODO implémenter ces conditions sur le serveur
    return !ARBleUtils.canBeOrdered(
      this.orderItem,
      !!this.currentCampaign,
      this.isT1OrderCurrentlyOpen,
      this.isT2OrderCurrentlyOpen,
      this.isT3OrderCurrentlyOpen,
      this.isT3DataHasStarted,
      this.isT3DataCurrentlyOpen,
      this.productTypesIndex,
      this.frequenciesIndex,
      this.consoleModulationTypesIndex,
    );
  }

  canDetermineOrderType() {
    return this.numPassages == 4 || (this.lastPassage && (this.numPassages != 1 || !isEmpty(this.hasZonage)));
  }

  onChangeNumPassages(numPassages: number) {
    if (this.isAdviceTypeLocked) {
      return;
    }

    this.numPassages = numPassages;

    if (this.numPassages != 4 && !this.lastPassage) {
      // pas de traitement spécial pour batch
      // si orderType est changé par le user, on n'essaie pas de merger =>
      // on met le DFE d'office comme sans le batch
      this.lastPassage = 'DFE';
    }

    this.commitOrderType();
  }

  onChangeLastPassage(lastPassage: string) {
    if (this.isAdviceTypeLocked) {
      return;
    }

    this.lastPassage = lastPassage;

    this.commitOrderType();
  }

  onChangeZonage(zonageChoice: number) {
    // champ virtuel : n'existe pas mais sera utilisé pour la sauvegarde
    (<any>this.cbBatchEdit)['consoleModulationType'] = true;

    if (zonageChoice == 1) {
      this.hasZonage = false;
      this.commitOrderType();

      this.commonConsoleModulationType = null;

      // rien de spécial
      // effacer les infos de zonage
      this.prepareNewT1ZonageData();
      this.prepareNewT2ZonageData();
      this.prepareNewT3ZonageData();
      this.prepareNewDnZonageData();
    } else if (zonageChoice == 2) {
      this.hasZonage = true;
      this.commitOrderType();

      this.prepareNewT1ZonageData();
      this.prepareNewT2ZonageData();
      this.prepareNewT3ZonageData();
      this.prepareNewDnZonageData();

      // id directement ; suppose pareil sur tous les env
      // pas de zonage console
      this.commonConsoleModulationType = new ARConsoleModulationType();
      this.commonConsoleModulationType.id = 1;

      if (this.hasT1) {
        // TODO ou partager l'objet ?
        this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t1ConsoleModulationType.id = this.commonConsoleModulationType.id;
      }

      if (this.hasT2) {
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t2ConsoleModulationType.id = this.commonConsoleModulationType.id;
      }

      if (this.hasDn) {
        this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.dnConsoleModulationType.id = this.commonConsoleModulationType.id;
      }

      if (this.hasT3) {
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t3ConsoleModulationType.id = this.commonConsoleModulationType.id;
      }
    } else if (zonageChoice == 3) {
      this.hasZonage = true;
      this.commitOrderType();

      this.commonConsoleModulationType = new ARConsoleModulationType();
      this.commonConsoleModulationType.id = 2;

      if (this.hasT1) {
        this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t1ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT1Ref.first) {
          this.vraEditT1Ref.first.onChangeConsoleModulationType(this.orderItem.t1ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t1ConsoleModulationType = null;
      }

      if (this.hasT2) {
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t2ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT2Ref.first) {
          this.vraEditT2Ref.first.onChangeConsoleModulationType(this.orderItem.t2ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t2ConsoleModulationType = null;
      }

      if (this.hasDn) {
        this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.dnConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditDnRef.first) {
          this.vraEditDnRef.first.onChangeConsoleModulationType(this.orderItem.dnConsoleModulationType.id);
        }
      } else {
        this.orderItem.dnConsoleModulationType = null;
      }

      if (this.hasT3) {
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t3ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT3Ref.first) {
          this.vraEditT3Ref.first.onChangeConsoleModulationType(this.orderItem.t3ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t3ConsoleModulationType = null;
      }
    } else if (zonageChoice == 4) {
      this.hasZonage = true;
      this.commitOrderType();

      this.commonConsoleModulationType = new ARConsoleModulationType();
      this.commonConsoleModulationType.id = 3;

      if (this.hasT1) {
        this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t1ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT1Ref.first) {
          this.vraEditT1Ref.first.onChangeConsoleModulationType(this.orderItem.t1ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t1ConsoleModulationType = null;
      }

      if (this.hasT2) {
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t2ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT2Ref.first) {
          this.vraEditT2Ref.first.onChangeConsoleModulationType(this.orderItem.t2ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t2ConsoleModulationType = null;
      }

      if (this.hasDn) {
        this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.dnConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditDnRef.first) {
          this.vraEditDnRef.first.onChangeConsoleModulationType(this.orderItem.dnConsoleModulationType.id);
        }
      } else {
        this.orderItem.dnConsoleModulationType = null;
      }

      if (this.hasT3) {
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t3ConsoleModulationType.id = this.commonConsoleModulationType.id;
        if (this.vraEditT3Ref.first) {
          this.vraEditT3Ref.first.onChangeConsoleModulationType(this.orderItem.t3ConsoleModulationType.id);
        }
      } else {
        this.orderItem.t3ConsoleModulationType = null;
      }
    }
  }

  prepareConsoleModulationType() {
    // toutes les memes :
    // donc on prend la premiere
    // TODO remplacer les champs dans la base par un seul commun
    this.commonConsoleModulationType = new ARConsoleModulationType();
    if (this.orderItem.t1ConsoleModulationType) {
      this.commonConsoleModulationType.id = this.orderItem.t1ConsoleModulationType.id;
    } else if (this.orderItem.t2ConsoleModulationType) {
      this.commonConsoleModulationType.id = this.orderItem.t2ConsoleModulationType.id;
    } else if (this.orderItem.dnConsoleModulationType) {
      this.commonConsoleModulationType.id = this.orderItem.dnConsoleModulationType.id;
    } else if (this.orderItem.t3ConsoleModulationType) {
      this.commonConsoleModulationType.id = this.orderItem.t3ConsoleModulationType.id;
    }
  }

  prepareOrderType(isInit = false) {
    this.setupFromOrderType();

    this.onChangeOrderT1(this.hasT1, isInit);
    this.onChangeOrderT2(this.hasT2, isInit);
    this.onChangeOrderDn(this.hasDn, isInit);
    this.onChangeOrderT3(this.hasT3, isInit);
  }

  commitOrderType() {
    // Determine order type selon les controles de l'UI : passage, stade, zonage

    if (!this.canDetermineOrderType()) {
      // vider
      this.orderItem.orderType = null;

      // verif si ça vient du hasZonage qui est non rempli
      if (this.numPassages == 1 && isEmpty(this.hasZonage)) {
        this.hasT1 = false;
        this.hasT2 = false;

        this.onChangeOrderT1(this.hasT1);
        this.onChangeOrderT2(this.hasT2);

        if (this.isBatch) {
          this.batchSet1Passage();
        }

        // le reste on garde comme avant
        // // pour le batch : on ne change pas la visibilité des stades
        // if(!this.isBatch) {
        //     // normalement les autres devraient passer (defaut pour le lastPassage + pas besoin du zonage)
        //     // on cache tout : sera remis quand toutes les infos necessaire seront remises
        //     this.hasT1 = false;
        //     this.hasT2 = false;
        //     this.hasDn = false;
        //     this.hasT3 = false;
        //     this.hasT3Tn = false;
        //     this.hasT3Dfe = false;
        // }
      }

      // si isBatch on ne met pas le orderType dans les champs en commun encore
      return;
    }

    if (this.numPassages == 4) {
      this.orderItem.orderType = this.orderTypesIndex.get('T1_T2_2N_T3');
    } else if (this.numPassages == 3) {
      if (this.lastPassage == '2N') {
        this.orderItem.orderType = this.orderTypesIndex.get('T1_T2_2N');
      } else if (this.lastPassage == '3N') {
        this.orderItem.orderType = this.orderTypesIndex.get('T1_T2_T3@3N');
      } else if (this.lastPassage == 'DFE') {
        this.orderItem.orderType = this.orderTypesIndex.get('T1_T2_T3@DFE');
      }
    } else if (this.numPassages == 2) {
      if (this.lastPassage == '2N') {
        this.orderItem.orderType = this.orderTypesIndex.get('T2_2N');
      } else if (this.lastPassage == '3N') {
        this.orderItem.orderType = this.orderTypesIndex.get('T2_T3@3N');
      } else if (this.lastPassage == 'DFE') {
        this.orderItem.orderType = this.orderTypesIndex.get('T2_T3@DFE');
      }
    } else if (this.numPassages == 1) {
      if (this.lastPassage == '2N') {
        if (this.hasZonage) {
          this.orderItem.orderType = this.orderTypesIndex.get('2N');
        } else {
          this.orderItem.orderType = this.orderTypesIndex.get('2N_SIMP');
        }
      } else if (this.lastPassage == '3N') {
        if (this.hasZonage) {
          this.orderItem.orderType = this.orderTypesIndex.get('T3@3N');
        } else {
          this.orderItem.orderType = this.orderTypesIndex.get('T3@3N_SIMP');
        }
      } else if (this.lastPassage == 'DFE') {
        if (this.hasZonage) {
          this.orderItem.orderType = this.orderTypesIndex.get('T3@DFE');
        } else {
          this.orderItem.orderType = this.orderTypesIndex.get('T3@DFE_SIMP');
        }
      }
    }

    if (this.isBatch) {
      (<any>this.cbBatchEdit)['orderType'] = true;
    }

    this.prepareOrderType();
  }

  setupFromOrderType() {
    // defaut
    this.hasT1 = undefined;
    this.hasT2 = undefined;
    this.hasDn = undefined;
    this.hasT3 = undefined;
    this.hasT3Dfe = undefined;
    this.hasT3Tn = undefined;
    this.hasZonage = undefined;
    this.numPassages = undefined;
    this.lastPassage = undefined;

    if (!this.orderItem.orderType || !this.orderItem.orderType.id) {
      // soit pas rentré , soit batch avec valeurs différentes
      if (this.isBatch) {
        this.batchMergePassages();
      }
      return;
    }

    if (this.orderItem.orderType.code == 'T1_T2_2N_T3') {
      this.hasT1 = true;
      this.hasT2 = true;
      this.hasDn = true;
      this.hasT3 = true;
      this.hasT3Dfe = true;
      this.hasT3Tn = false;
      this.hasZonage = true;
      this.numPassages = 4;
      this.lastPassage = 'DFE';
    } else if (this.orderItem.orderType.code == 'T1_T2_2N') {
      this.hasT1 = true;
      this.hasT2 = true;
      this.hasDn = true;
      this.hasT3 = false;
      this.hasT3Tn = false;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 3;
      this.lastPassage = '2N';
    } else if (this.orderItem.orderType.code == 'T1_T2_T3@3N') {
      this.hasT1 = true;
      this.hasT2 = true;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = true;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 3;
      this.lastPassage = '3N';
    } else if (this.orderItem.orderType.code == 'T1_T2_T3@DFE') {
      this.hasT1 = true;
      this.hasT2 = true;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = false;
      this.hasT3Dfe = true;
      this.hasZonage = true;
      this.numPassages = 3;
      this.lastPassage = 'DFE';
    } else if (this.orderItem.orderType.code == 'T2_2N') {
      this.hasT1 = false;
      this.hasT2 = true;
      this.hasDn = true;
      this.hasT3 = false;
      this.hasT3Tn = false;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 2;
      this.lastPassage = '2N';
    } else if (this.orderItem.orderType.code == 'T2_T3@3N') {
      this.hasT1 = false;
      this.hasT2 = true;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = true;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 2;
      this.lastPassage = '3N';
    } else if (this.orderItem.orderType.code == 'T2_T3@DFE') {
      this.hasT1 = false;
      this.hasT2 = true;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = false;
      this.hasT3Dfe = true;
      this.hasZonage = true;
      this.numPassages = 2;
      this.lastPassage = 'DFE';
    } else if (this.orderItem.orderType.code == '2N') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = true;
      this.hasT3 = false;
      this.hasT3Tn = false;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 1;
      this.lastPassage = '2N';
    } else if (this.orderItem.orderType.code == 'T3@3N') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = true;
      this.hasT3Dfe = false;
      this.hasZonage = true;
      this.numPassages = 1;
      this.lastPassage = '3N';
    } else if (this.orderItem.orderType.code == 'T3@DFE') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = false;
      this.hasT3Dfe = true;
      this.hasZonage = true;
      this.numPassages = 1;
      this.lastPassage = 'DFE';
    } else if (this.orderItem.orderType.code == '2N_SIMP') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = true;
      this.hasT3 = false;
      this.hasT3Tn = false;
      this.hasT3Dfe = false;
      this.hasZonage = false;
      this.numPassages = 1;
      this.lastPassage = '2N';
    } else if (this.orderItem.orderType.code == 'T3@3N_SIMP') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = true;
      this.hasT3Dfe = false;
      this.hasZonage = false;
      this.numPassages = 1;
      this.lastPassage = '3N';
    } else if (this.orderItem.orderType.code == 'T3@DFE_SIMP') {
      this.hasT1 = false;
      this.hasT2 = false;
      this.hasDn = false;
      this.hasT3 = true;
      this.hasT3Tn = false;
      this.hasT3Dfe = true;
      this.hasZonage = false;
      this.numPassages = 1;
      this.lastPassage = 'DFE';
    }
  }

  batchMergePassages() {
    // les orderItem recup du serveur ne sont pas des objets BleOrderItem
    // => ils ont les hasT1 déterminés avec le orderType par le serveur
    // PAr contre le cbBatchEdit se base sur les propriétés du BleOrdrItem donc
    // pas de hasT1, hasT2....
    const hasT1 = this.checkPropertyValue('hasT1');
    this.hasT1 = hasT1[1];
    const hasT2 = this.checkPropertyValue('hasT2');
    this.hasT2 = hasT2[1];
    const hasT3 = this.checkPropertyValue('hasT3');
    this.hasT3 = hasT3[1];
    const hasDn = this.checkPropertyValue('hasDn');
    this.hasDn = hasDn[1];
    const hasZonage = this.checkPropertyValue('hasZonage');
    this.hasZonage = hasZonage[1];
  }

  checkPropertyValue(propertyName: string) {
    let value: any = undefined;
    let isCommon: boolean = false;
    for (const orderItem of this.batchOrderItems) {
      const propertyValue: any = (<any>orderItem)[propertyName];
      if (value === undefined) {
        // première valeure
        isCommon = true;
        if (propertyValue !== undefined) {
          // on prend la valeur du champ pour l'instant
          value = propertyValue;
        } else {
          // on laisse le champ vide mais on distingue du cas non initialisé
          // un champ vide peut êtte valide
          value = null;
        }
      } else {
        // choix libre
        if (
          (value !== null && value !== propertyValue) ||
          (value === null && !(propertyValue === null || propertyValue === undefined))
        ) {
          value = null;
          isCommon = false;
          break;
        }
      }
    }
    return [isCommon, value];
  }

  batchSet1Passage() {
    this.batchOrderItems.forEach((x) => {
      // on set le code de l'item selon la valeur précendete
      // si pas de valeur avant => vide
      // sera pris en compte pour la sauvegarde
      if (x.hasDn) {
        if (x.hasZonage) {
          x.orderType = this.orderTypesIndex.get('2N');
        } else {
          x.orderType = this.orderTypesIndex.get('2N_SIMP');
        }
      } else if (x.hasT3) {
        if (x.hasT3Tn) {
          if (x.hasZonage) {
            x.orderType = this.orderTypesIndex.get('T3@3N');
          } else {
            x.orderType = this.orderTypesIndex.get('T3@3N_SIMP');
          }
        } else if (x.hasT3Dfe) {
          if (x.hasZonage) {
            x.orderType = this.orderTypesIndex.get('T3@DFE');
          } else {
            x.orderType = this.orderTypesIndex.get('T3@DFE_SIMP');
          }
        }
      }
    });
  }

  isOrderTypeFilled() {
    if (!this.isBatch) {
      return !!(this.orderItem.orderType && this.orderItem.orderType.id);
    }

    if (this.orderItem.orderType && this.orderItem.orderType.id) {
      // rempli explicitement ou meme pour tous si edition
      return true;
    }

    let isOK: boolean = true;
    this.batchOrderItems.forEach((x) => {
      if (!x.id) {
        // si pas encore créé, le orderType de l'UI doit être remplie (s'appliquera à tous)
        // mais condition deja testee : pas le cas donc erreur
        isOK = false;
      }
    });
    return isOK;
  }

  onChangeOrderT1(isOrderedT1: any, isInit = false) {
    isOrderedT1 = toBoolean(isOrderedT1);
    if (!isInit) {
      if (!isOrderedT1) {
        this.prepareNewT1Data();
      } else {
        if (this.commonConsoleModulationType) {
          this.orderItem.t1ConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.t1ConsoleModulationType.id = this.commonConsoleModulationType.id;
        }
      }

      this.hasT1Changed = true;
    } else {
      if (!isOrderedT1) {
        this.prepareNewT1Data();
      }
    }
  }

  onChangeOrderT2(isOrderedT2: any, isInit = false) {
    isOrderedT2 = toBoolean(isOrderedT2);

    if (!isInit) {
      if (!isOrderedT2) {
        this.prepareNewT2Data();
      } else {
        if (this.commonConsoleModulationType) {
          this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.t2ConsoleModulationType.id = this.commonConsoleModulationType.id;
        }
      }

      this.hasT2Changed = true;
    } else {
      if (!isOrderedT2) {
        this.prepareNewT2Data();
      }
    }
  }

  onChangeOrderT3(isOrderedT3: any, isInit = false) {
    isOrderedT3 = toBoolean(isOrderedT3);

    if (!isInit) {
      if (!isOrderedT3) {
        this.prepareNewT3Data();
      } else {
        if (this.commonConsoleModulationType) {
          this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.t3ConsoleModulationType.id = this.commonConsoleModulationType.id;
        }
      }

      this.hasT3Changed = true;
    } else {
      if (!isOrderedT3) {
        this.prepareNewT3Data();
      }
    }
  }

  onChangeOrderDn(isOrderedDn: any, isInit = false) {
    isOrderedDn = toBoolean(isOrderedDn);

    if (!isInit) {
      if (!isOrderedDn) {
        this.prepareNewDnData();
      } else {
        if (this.commonConsoleModulationType) {
          this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.dnConsoleModulationType.id = this.commonConsoleModulationType.id;
        }
      }

      this.hasDnChanged = true;
    } else {
      if (!isOrderedDn) {
        this.prepareNewDnData();
      }
    }
  }

  // les t1t2t3Links indiquent si un changement dans T1 doit aussi changer T2 (vu que pas vide après le 1er changement)
  // seulement au premier remplissage (jusqu'à Sauver) ; si édité par la suite pas de lien
  onChangeT1Fertilizer(isEvent: boolean = true) {
    // vide : pas de propagation
    if (
      !this.orderItem.t1FertilizerConcentration &&
      !(this.orderItem.t1FertilizerType && this.orderItem.t1FertilizerType.id)
    ) {
      return;
    }

    // propage à T2
    // seulement si pas déjà rempli
    if (!this.orderItem.t2FertilizerConcentration || this.t1t2t3Links.get('t2FertilizerConcentration')) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2FertilizerConcentration']) {
        this.orderItem.t2FertilizerConcentration = this.orderItem.t1FertilizerConcentration;
        this.t1t2t3Links.set('t2FertilizerConcentration', true);
      }
    }
    if (
      this.orderItem.t1FertilizerType &&
      this.orderItem.t1FertilizerType.id &&
      (!this.orderItem.t2FertilizerType ||
        !this.orderItem.t2FertilizerType.id ||
        this.t1t2t3Links.get('t2FertilizerType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2FertilizerType']) {
        this.orderItem.t2FertilizerType = new ARFertilizerType();
        this.orderItem.t2FertilizerType.id = this.orderItem.t1FertilizerType.id;
        this.t1t2t3Links.set('t2FertilizerType', true);
      }
    }

    // on propage à T3 2N + DFE aussi
    this.onChangeT2Fertilizer(false);
  }

  onChangeT2Fertilizer(isEvent: boolean = true) {
    if (isEvent) {
      // changé manuellement => changer t1 ne va plus changer T2
      this.t1t2t3Links.set('t2FertilizerConcentration', false);
      this.t1t2t3Links.set('t2FertilizerType', false);
    }

    if (
      !this.orderItem.t2FertilizerConcentration &&
      !(this.orderItem.t2FertilizerType && this.orderItem.t2FertilizerType.id)
    ) {
      return;
    }

    // 2 seuls choix possibles si T2 est choisi : avec DN + DFE ou juste DFE
    // FIXME changer : commentaire plus valide : 4 passages a 2N + DFE (T3)
    if (this.hasDn) {
      // seulement si pas déjà rempli
      if (!this.orderItem.dnFertilizerConcentration || this.t1t2t3Links.get('dnFertilizerConcentration')) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnFertilizerConcentration']) {
          this.orderItem.dnFertilizerConcentration = this.orderItem.t2FertilizerConcentration;
          this.t1t2t3Links.set('dnFertilizerConcentration', true);
        }
      }
      if (
        this.orderItem.t2FertilizerType &&
        this.orderItem.t2FertilizerType.id &&
        (!this.orderItem.dnFertilizerType ||
          !this.orderItem.dnFertilizerType.id ||
          this.t1t2t3Links.get('dnFertilizerType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnFertilizerType']) {
          this.orderItem.dnFertilizerType = new ARFertilizerType();
          this.orderItem.dnFertilizerType.id = this.orderItem.t2FertilizerType.id;
          this.t1t2t3Links.set('dnFertilizerType', true);
        }
      }

      this.onChangeDnFertilizer(false);
    }

    if (this.hasT3 && !this.hasDn) {
      // a t3 DFE mais pas 2N
      // pas de propagation si la rentrée des données T3 n'est pas ouverte
      if (!this.isT3DataHasStarted) {
        return;
      }

      // seulement si pas déjà rempli
      if (!this.orderItem.t3FertilizerConcentration || this.t1t2t3Links.get('t3FertilizerConcentration')) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3FertilizerConcentration']) {
          this.orderItem.t3FertilizerConcentration = this.orderItem.t2FertilizerConcentration;
          this.t1t2t3Links.set('t3FertilizerConcentration', true);
        }
      }
      if (
        this.orderItem.t2FertilizerType &&
        this.orderItem.t2FertilizerType.id &&
        (!this.orderItem.t3FertilizerType ||
          !this.orderItem.t3FertilizerType.id ||
          this.t1t2t3Links.get('t3FertilizerType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3FertilizerType']) {
          this.orderItem.t3FertilizerType = new ARFertilizerType();
          this.orderItem.t3FertilizerType.id = this.orderItem.t2FertilizerType.id;
          this.t1t2t3Links.set('t3FertilizerType', true);
        }
      }
      this.onChangeT3Fertilizer(false);
    }
  }

  onChangeDnFertilizer(isEvent: boolean = true) {
    // TODO voir que faire si : DN change manuellement => DFE change (liés) mais ensuite au lieu de T1+T2+DFE+2N => sélection de T1+T2+DFE,
    // la structure va lier DFE à celui d'avant qui sera T2 (mais pas nécessairement identiques...)
    if (isEvent) {
      // changé manuellement => changer T2 ne va plus changer 2N
      this.t1t2t3Links.set('dnFertilizerConcentration', false);
      this.t1t2t3Links.set('dnFertilizerType', false);
    }

    if (
      !this.orderItem.dnFertilizerConcentration &&
      !(this.orderItem.dnFertilizerType && this.orderItem.dnFertilizerType.id)
    ) {
      return;
    }

    if (this.hasT3) {
      // pas de propagation si la rentrée des données T3 n'est pas ouverte
      if (!this.isT3DataHasStarted) {
        return;
      }
      // seulement si pas déjà rempli
      if (!this.orderItem.t3FertilizerConcentration || this.t1t2t3Links.get('t3FertilizerConcentration')) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3FertilizerConcentration']) {
          this.orderItem.t3FertilizerConcentration = this.orderItem.t2FertilizerConcentration;
          this.t1t2t3Links.set('t3FertilizerConcentration', true);
        }
      }
      if (
        this.orderItem.dnFertilizerType &&
        this.orderItem.dnFertilizerType.id &&
        (!this.orderItem.t3FertilizerType ||
          !this.orderItem.t3FertilizerType.id ||
          this.t1t2t3Links.get('t3FertilizerType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3FertilizerType']) {
          this.orderItem.t3FertilizerType = new ARFertilizerType();
          this.orderItem.t3FertilizerType.id = this.orderItem.dnFertilizerType.id;
          this.t1t2t3Links.set('t3FertilizerType', true);
        }
      }

      this.onChangeT3Fertilizer(false);
    }
  }

  onChangeT3Fertilizer(isEvent: boolean = true) {
    if (isEvent) {
      this.t1t2t3Links.set('t3FertilizerConcentration', false);
      this.t1t2t3Links.set('t3FertilizerType', false);
    }
  }

  onChangeT1Vra(isEvent: boolean = true) {
    // propage à T2
    // seulement si pas déjà rempli

    // rien de rempli
    if (
      !(this.orderItem.t1ConsoleModulationType && this.orderItem.t1ConsoleModulationType.id) &&
      !(this.orderItem.t1ConsoleType && this.orderItem.t1ConsoleType.id) &&
      !(this.orderItem.t1ConsoleVersion && this.orderItem.t1ConsoleVersion.id) &&
      !(this.orderItem.t1ConsoleFormatType && this.orderItem.t1ConsoleFormatType.id) &&
      !this.orderItem.t1OtherConsoleVersion
    ) {
      return;
    }

    if (
      this.orderItem.t1ConsoleModulationType &&
      this.orderItem.t1ConsoleModulationType.id &&
      (!this.orderItem.t2ConsoleModulationType ||
        !this.orderItem.t2ConsoleModulationType.id ||
        this.t1t2t3Links.get('t2ConsoleModulationType'))
    ) {
      // cas batch => on ne propage pas si la modulation type ne match pas
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2ConsoleModulationType']) {
        this.orderItem.t2ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t2ConsoleModulationType.id = this.orderItem.t1ConsoleModulationType.id;
        this.t1t2t3Links.set('t2ConsoleModulationType', true);

        if (this.vraEditT2Ref.first) {
          this.vraEditT2Ref.first.onChangeConsoleModulationType(this.orderItem.t2ConsoleModulationType.id);
          // va changer les autres champs aussi => on les met dans links
          this.t1t2t3Links.set('t2ConsoleType', true);
          this.t1t2t3Links.set('t2ConsoleVersion', true);
          this.t1t2t3Links.set('t2ConsoleFormatType', true);
          this.t1t2t3Links.set('t2OtherConsoleVersion', true);
        }
      }
    }
    if (
      this.orderItem.t1ConsoleType &&
      this.orderItem.t1ConsoleType.id &&
      (!this.orderItem.t2ConsoleType || !this.orderItem.t2ConsoleType.id || this.t1t2t3Links.get('t2ConsoleType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2ConsoleType']) {
        this.orderItem.t2ConsoleType = new ARConsoleType();
        this.orderItem.t2ConsoleType.id = this.orderItem.t1ConsoleType.id;
        this.t1t2t3Links.set('t2ConsoleType', true);
      }
    }
    if (
      this.orderItem.t1ConsoleVersion &&
      this.orderItem.t1ConsoleVersion.id &&
      (!this.orderItem.t2ConsoleVersion ||
        !this.orderItem.t2ConsoleVersion.id ||
        this.t1t2t3Links.get('t2ConsoleVersion'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2ConsoleVersion']) {
        this.orderItem.t2ConsoleVersion = new ARConsoleVersion();
        this.orderItem.t2ConsoleVersion.id = this.orderItem.t1ConsoleVersion.id;
        this.t1t2t3Links.set('t2ConsoleVersion', true);
      }
    }
    if (
      this.orderItem.t1ConsoleFormatType &&
      this.orderItem.t1ConsoleFormatType.id &&
      (!this.orderItem.t2ConsoleFormatType ||
        !this.orderItem.t2ConsoleFormatType.id ||
        this.t1t2t3Links.get('t2ConsoleFormatType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2ConsoleFormatType']) {
        this.orderItem.t2ConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.t2ConsoleFormatType.id = this.orderItem.t1ConsoleFormatType.id;
        this.t1t2t3Links.set('t2ConsoleFormatType', true);
      }
    }
    if (!this.orderItem.t2OtherConsoleVersion || this.t1t2t3Links.get('t2OtherConsoleVersion')) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t2OtherConsoleVersion']) {
        this.orderItem.t2OtherConsoleVersion = this.orderItem.t1OtherConsoleVersion;
        this.t1t2t3Links.set('t2OtherConsoleVersion', true);
      }
    }

    // on propage à T3 aussi
    this.onChangeT2Vra(false);
  }

  onChangeT2Vra(isEvent: boolean = true) {
    if (isEvent) {
      // changé manuellement => changer t1 ne va plus changer T2
      this.t1t2t3Links.set('t2ConsoleFormatType', false);
      this.t1t2t3Links.set('t2ConsoleType', false);
      this.t1t2t3Links.set('t2ConsoleVersion', false);
      this.t1t2t3Links.set('t2ConsoleModulationType', false);
      this.t1t2t3Links.set('t2OtherConsoleVersion', false);
    }

    if (
      !(this.orderItem.t2ConsoleModulationType && this.orderItem.t2ConsoleModulationType.id) &&
      !(this.orderItem.t2ConsoleType && this.orderItem.t2ConsoleType.id) &&
      !(this.orderItem.t2ConsoleVersion && this.orderItem.t2ConsoleVersion.id) &&
      !(this.orderItem.t2ConsoleFormatType && this.orderItem.t2ConsoleFormatType.id) &&
      !this.orderItem.t2OtherConsoleVersion
    ) {
      return;
    }

    if (this.hasDn) {
      if (
        this.orderItem.t2ConsoleModulationType &&
        this.orderItem.t2ConsoleModulationType.id &&
        (!this.orderItem.dnConsoleModulationType ||
          !this.orderItem.dnConsoleModulationType.id ||
          this.t1t2t3Links.get('dnConsoleModulationType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnConsoleModulationType']) {
          this.orderItem.dnConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.dnConsoleModulationType.id = this.orderItem.t2ConsoleModulationType.id;
          this.t1t2t3Links.set('dnConsoleModulationType', true);
          if (this.vraEditT3Ref.first) {
            this.vraEditT3Ref.first.onChangeConsoleModulationType(this.orderItem.dnConsoleModulationType.id);
            // va changer les autres champs aussi => on les met dans links
            this.t1t2t3Links.set('dnConsoleType', true);
            this.t1t2t3Links.set('dnConsoleVersion', true);
            this.t1t2t3Links.set('dnConsoleFormatType', true);
            this.t1t2t3Links.set('dnOtherConsoleVersion', true);
          }
        }
      }
      if (
        this.orderItem.t2ConsoleType &&
        this.orderItem.t2ConsoleType.id &&
        (!this.orderItem.dnConsoleType || !this.orderItem.dnConsoleType.id || this.t1t2t3Links.get('dnConsoleType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnConsoleType']) {
          this.orderItem.dnConsoleType = new ARConsoleType();
          this.orderItem.dnConsoleType.id = this.orderItem.t2ConsoleType.id;
          this.t1t2t3Links.set('dnConsoleType', true);
        }
      }
      if (
        this.orderItem.t2ConsoleVersion &&
        this.orderItem.t2ConsoleVersion.id &&
        (!this.orderItem.dnConsoleVersion ||
          !this.orderItem.dnConsoleVersion.id ||
          this.t1t2t3Links.get('dnConsoleVersion'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnConsoleVersion']) {
          this.orderItem.dnConsoleVersion = new ARConsoleVersion();
          this.orderItem.dnConsoleVersion.id = this.orderItem.t2ConsoleVersion.id;
          this.t1t2t3Links.set('dnConsoleVersion', true);
        }
      }
      if (
        this.orderItem.t2ConsoleFormatType &&
        this.orderItem.t2ConsoleFormatType.id &&
        (!this.orderItem.dnConsoleFormatType ||
          !this.orderItem.dnConsoleFormatType.id ||
          this.t1t2t3Links.get('dnConsoleFormatType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnConsoleFormatType']) {
          this.orderItem.dnConsoleFormatType = new ARConsoleFormatType();
          this.orderItem.dnConsoleFormatType.id = this.orderItem.t2ConsoleFormatType.id;
          this.t1t2t3Links.set('dnConsoleFormatType', true);
        }
      }

      if (!this.orderItem.dnOtherConsoleVersion || this.t1t2t3Links.get('dnOtherConsoleVersion')) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['dnOtherConsoleVersion']) {
          this.orderItem.dnOtherConsoleVersion = this.orderItem.t2OtherConsoleVersion;
          this.t1t2t3Links.set('dnOtherConsoleVersion', true);
        }
      }

      this.onChangeDnVra(false);
    }

    // FIXME a T3 sans DN : OK pour les 3 passages ; 4 passages : propagration T3 faite via DN
    if (this.hasT3 && !this.hasDn) {
      // propage vers T3
      // pas de propagation si la rentrée des données T3 n'est pas ouverte
      // même si la prochaine édition après ouverture va les remplir automatique selon T2
      if (!this.isT3DataHasStarted) {
        return;
      }

      if (
        this.orderItem.t2ConsoleModulationType &&
        this.orderItem.t2ConsoleModulationType.id &&
        (!this.orderItem.t3ConsoleModulationType ||
          !this.orderItem.t3ConsoleModulationType.id ||
          this.t1t2t3Links.get('t3ConsoleModulationType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleModulationType']) {
          this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
          this.orderItem.t3ConsoleModulationType.id = this.orderItem.t2ConsoleModulationType.id;
          this.t1t2t3Links.set('t3ConsoleModulationType', true);
          if (this.vraEditT3Ref.first) {
            this.vraEditT3Ref.first.onChangeConsoleModulationType(this.orderItem.t3ConsoleModulationType.id);
            // va changer les autres champs aussi => on les met dans links
            this.t1t2t3Links.set('t3ConsoleType', true);
            this.t1t2t3Links.set('t3ConsoleVersion', true);
            this.t1t2t3Links.set('t3ConsoleFormatType', true);
            this.t1t2t3Links.set('t3OtherConsoleVersion', true);
          }
        }
      }
      if (
        this.orderItem.t2ConsoleType &&
        this.orderItem.t2ConsoleType.id &&
        (!this.orderItem.t3ConsoleType || !this.orderItem.t3ConsoleType.id || this.t1t2t3Links.get('t3ConsoleType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleType']) {
          this.orderItem.t3ConsoleType = new ARConsoleType();
          this.orderItem.t3ConsoleType.id = this.orderItem.t2ConsoleType.id;
          this.t1t2t3Links.set('t3ConsoleType', true);
        }
      }
      if (
        this.orderItem.t2ConsoleVersion &&
        this.orderItem.t2ConsoleVersion.id &&
        (!this.orderItem.t3ConsoleVersion ||
          !this.orderItem.t3ConsoleVersion.id ||
          this.t1t2t3Links.get('t3ConsoleVersion'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleVersion']) {
          this.orderItem.t3ConsoleVersion = new ARConsoleVersion();
          this.orderItem.t3ConsoleVersion.id = this.orderItem.t2ConsoleVersion.id;
          this.t1t2t3Links.set('t3ConsoleVersion', true);
        }
      }
      if (
        this.orderItem.t2ConsoleFormatType &&
        this.orderItem.t2ConsoleFormatType.id &&
        (!this.orderItem.t3ConsoleFormatType ||
          !this.orderItem.t3ConsoleFormatType.id ||
          this.t1t2t3Links.get('t3ConsoleFormatType'))
      ) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleFormatType']) {
          this.orderItem.t3ConsoleFormatType = new ARConsoleFormatType();
          this.orderItem.t3ConsoleFormatType.id = this.orderItem.t2ConsoleFormatType.id;
          this.t1t2t3Links.set('t3ConsoleFormatType', true);
        }
      }

      if (!this.orderItem.t3OtherConsoleVersion || this.t1t2t3Links.get('t3OtherConsoleVersion')) {
        if (!this.isBatch || (<any>this.cbBatchEdit)['t3OtherConsoleVersion']) {
          this.orderItem.t3OtherConsoleVersion = this.orderItem.t2OtherConsoleVersion;
          this.t1t2t3Links.set('t3OtherConsoleVersion', true);
        }
      }
    }
  }

  onChangeDnVra(isEvent: boolean = true) {
    if (isEvent) {
      // changé manuellement => changer t1 ne va plus changer T2
      this.t1t2t3Links.set('dnConsoleFormatType', false);
      this.t1t2t3Links.set('dnConsoleType', false);
      this.t1t2t3Links.set('dnConsoleVersion', false);
      this.t1t2t3Links.set('dnConsoleModulationType', false);
      this.t1t2t3Links.set('dnOtherConsoleVersion', false);
    }

    if (
      !(this.orderItem.dnConsoleModulationType && this.orderItem.dnConsoleModulationType.id) &&
      !(this.orderItem.dnConsoleType && this.orderItem.dnConsoleType.id) &&
      !(this.orderItem.dnConsoleVersion && this.orderItem.dnConsoleVersion.id) &&
      !(this.orderItem.dnConsoleFormatType && this.orderItem.dnConsoleFormatType.id) &&
      !this.orderItem.dnOtherConsoleVersion
    ) {
      return;
    }

    // pas de propagation si la rentrée des données dFE n'est pas ouverte
    // même si la prochaine édition après ouverture va les remplir automatique selon DN
    if (!this.isT3DataHasStarted) {
      return;
    }

    if (
      this.orderItem.dnConsoleModulationType &&
      this.orderItem.dnConsoleModulationType.id &&
      (!this.orderItem.t3ConsoleModulationType ||
        !this.orderItem.t3ConsoleModulationType.id ||
        this.t1t2t3Links.get('t3ConsoleModulationType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleModulationType']) {
        this.orderItem.t3ConsoleModulationType = new ARConsoleModulationType();
        this.orderItem.t3ConsoleModulationType.id = this.orderItem.dnConsoleModulationType.id;
        this.t1t2t3Links.set('t3ConsoleModulationType', true);
        if (this.vraEditT3Ref.first) {
          this.vraEditT3Ref.first.onChangeConsoleModulationType(this.orderItem.t3ConsoleModulationType.id);
          // va changer les autres champs aussi => on les met dans links
          this.t1t2t3Links.set('t3ConsoleType', true);
          this.t1t2t3Links.set('t3ConsoleVersion', true);
          this.t1t2t3Links.set('t3ConsoleFormatType', true);
          this.t1t2t3Links.set('t3OtherConsoleVersion', true);
        }
      }
    }
    if (
      this.orderItem.dnConsoleType &&
      this.orderItem.dnConsoleType.id &&
      (!this.orderItem.t3ConsoleType || !this.orderItem.t3ConsoleType.id || this.t1t2t3Links.get('t3ConsoleType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleType']) {
        this.orderItem.t3ConsoleType = new ARConsoleType();
        this.orderItem.t3ConsoleType.id = this.orderItem.dnConsoleType.id;
        this.t1t2t3Links.set('t3ConsoleType', true);
      }
    }
    if (
      this.orderItem.dnConsoleVersion &&
      this.orderItem.dnConsoleVersion.id &&
      (!this.orderItem.t3ConsoleVersion ||
        !this.orderItem.t3ConsoleVersion.id ||
        this.t1t2t3Links.get('t3ConsoleVersion'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleVersion']) {
        this.orderItem.t3ConsoleVersion = new ARConsoleVersion();
        this.orderItem.t3ConsoleVersion.id = this.orderItem.dnConsoleVersion.id;
        this.t1t2t3Links.set('t3ConsoleVersion', true);
      }
    }
    if (
      this.orderItem.dnConsoleFormatType &&
      this.orderItem.dnConsoleFormatType.id &&
      (!this.orderItem.t3ConsoleFormatType ||
        !this.orderItem.t3ConsoleFormatType.id ||
        this.t1t2t3Links.get('t3ConsoleFormatType'))
    ) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t3ConsoleFormatType']) {
        this.orderItem.t3ConsoleFormatType = new ARConsoleFormatType();
        this.orderItem.t3ConsoleFormatType.id = this.orderItem.dnConsoleFormatType.id;
        this.t1t2t3Links.set('t3ConsoleFormatType', true);
      }
    }

    if (!this.orderItem.t3OtherConsoleVersion || this.t1t2t3Links.get('t3OtherConsoleVersion')) {
      if (!this.isBatch || (<any>this.cbBatchEdit)['t3OtherConsoleVersion']) {
        this.orderItem.t3OtherConsoleVersion = this.orderItem.dnOtherConsoleVersion;
        this.t1t2t3Links.set('t3OtherConsoleVersion', true);
      }
    }
  }

  onChangeT3Vra(isEvent: boolean = true) {
    if (isEvent) {
      this.t1t2t3Links.set('t3ConsoleFormatType', false);
      this.t1t2t3Links.set('t3ConsoleType', false);
      this.t1t2t3Links.set('t3ConsoleVersion', false);
      this.t1t2t3Links.set('t3ConsoleModulationType', false);
      this.t1t2t3Links.set('t3OtherConsoleVersion', false);
    }
  }

  getOrganisation(): Observable<Organisation> {
    return this.userService.getMe().pipe(map((me) => me.organisation));
  }

  handleShowBeApi(organisation: Organisation) {
    // TODO quand i18n mergée : récupérer l'org depuis la structure
    const isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    const isNegoce = KeycloakService.auth.authz.hasRealmRole('ROLE_NEGOCE');
    if (isAdmin || isNegoce) {
      this.showBeApi = true;
      return;
    }

    this.showBeApi = organisation.hasBeApi;
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.unauthorized.edit'));
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, this.i18nTranslator.translate('edit.error.generic'));
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.unauthorized.view')).then((r) => {
        this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, this.i18nTranslator.translate('error.generic')).then((r) => {
        this.router.navigate(['/orders', 'azote', 'ble', 'parcels']);
      });
    }
  }

  handleSavebatchError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.unauthorized.edit.multiParcels'));
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, this.i18nTranslator.translate('ar.edit.error.save.multiParcels'));
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
